// BoundToEdge set as binary value to permit bitwise operations
// example: TopLeft = Top & Left
export enum BoundToEdge {
	'No' = 0,
	'Top' = 1,
	'Bottom' = 2,
	'Left' = 4,
	'Right' = 8,
	'TopLeft' = 5,
	'TopRight' = 9,
	'BottomLeft' = 6,
	'BottomRight' = 10
}
